import { IconInform } from "@/Icon/Inform";
import { NotifyDataTypes } from "./NotifySent";
import { formatDateToKorean } from "%/date";

const NotifyHeader = ({
  data,
  isUse = true,
}: {
  data: NotifyDataTypes;
  isUse: boolean;
}) => {
  return (
    <div className="flex flex-nowrap gap-2 justify-between items-center min-w-0">
      <div className="flex flex-nowrap gap-2 items-center min-w-0 flex-1 overflow-hidden">
        <IconInform active={data.readYn === "N"} />
        <div className="font-semibold truncate">{data.notiTitle}</div>
        {data.businessNewReplyYn === "Y" && (
          <div className="flex flex-shrink-0 justify-center items-center w-6 h-4 text-xs font-bold text-[#ff9934] bg-red-500 rounded">
            new
          </div>
        )}
      </div>
      {isUse && (
        <div className="flex flex-nowrap gap-2 flex-shrink-0 text-sm text-[#999999]">
          <span className="whitespace-nowrap">{data.recipientName}</span>
          <span>|</span>
          <span className="whitespace-nowrap">
            {formatDateToKorean(data.dtSend)}
          </span>
        </div>
      )}
    </div>
  );
};

export default NotifyHeader;
